import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Icon, { TrinityIconSet } from '@divvy-web/skylab.icon'

import styles from './styles.module.scss'

export interface OverviewLineItemProps {
  label: React.ReactNode
  subLabel?: React.ReactNode
  icon: TrinityIconSet
  value?: React.ReactNode
  dataTestId?: string
}

const OverviewLineItem = ({ label, value, icon, dataTestId, subLabel }: OverviewLineItemProps) => {
  const [getClassName, makeTestId] = useNameFormatter('OverviewLineItem')

  return (
    <div
      className={`${styles[getClassName('')]} ${subLabel && styles[getClassName('has-sub-label')]}`}
      data-testid={makeTestId(dataTestId ?? '')}
    >
      <div className={`${styles[getClassName('label')]} ${subLabel && styles[getClassName('has-sub-label')]}`}>
        <Icon name={icon} />
        <div className={styles[getClassName('label-text')]}>
          {label}
          {subLabel}
        </div>
      </div>
      {value ?? '—'}
    </div>
  )
}

export default OverviewLineItem
